import React from "react";
import "./Footer.css";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2 className="footer-title">ConsistencyAI</h2>
        <div className="social-links">
          <a href="https://www.instagram.com/consistencyai/" className="social-icon">
            <FaInstagram />
          </a>
          <a href="https://x.com/consistencyai" className="social-icon">
            <FaXTwitter />
          </a>
        </div>
      </div>
      <div className="footer-links">
        
        
      <Link to="/Terms-of-Service" className="footer-link">Terms of Service</Link>
      <Link to="/Privacy_Policy" className="footer-link">Privacy Policy</Link>
      <Link to="/End_User_License_Agreement" className="footer-link">End User License Agreement</Link>
        
      </div>
    </footer>
  );
};

export default Footer;
